<mat-card class="example-card fadeInDown responsive-card">
  <mat-card-header class="responsive-header">
    <img
      src="../../assets/img/FINAL_RGB-01.png"
      class="fadeIn first responsive-logo"
    />
  </mat-card-header>

  <mat-card-content>
    <form class="example-form fadeIn second responsive-form">
      <mat-form-field appearance="outline" class="example-full-width">
        <input
          class="input"
          matInput
          placeholder="Email"
          [formControl]="emailFormControl"
          appLowercaseInput
        />
        <mat-error
          *ngIf="
            emailFormControl.hasError('email') &&
            !emailFormControl.hasError('required')
          "
        >
          Please enter a valid email address
        </mat-error>
        <mat-error *ngIf="emailFormControl.hasError('required')">
          Email is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="example-full-width">
        <input
          class="input"
          type="password"
          matInput
          placeholder="Password"
          [formControl]="passwordFormControl"
        />
        <mat-error *ngIf="passwordFormControl.hasError('required')">
          Password is <strong>required</strong>
        </mat-error>
      </mat-form-field>

      <button
        type="submit"
        class="full fadeIn third primary"
        (click)="login()"
        mat-raised-button
        [disabled]="
          !emailFormControl.valid || !passwordFormControl.valid
        "
      >
        Login
      </button>

      <!-- <button
        type="button"
        class="full fadeIn third primary"
        (click)="createUser()"
        mat-raised-button
    
      >
        Add User
      </button> -->


        <!-- <button
        type="button"
        class="full fadeIn third primary"
        (click)="updateUser()"
        mat-raised-button
    
      >
        Update User
      </button> -->

<!--       
        <button
        type="button"
        class="full fadeIn third primary"
        (click)="TestAddaudit()"
        mat-raised-button
    
      >
      TestAddaudit
      </button>
       -->
    </form>
    <button
      type="button"
      class="full fadeIn fourth secondary"
      mat-button
      color="light"
      (click)="resetPassword()"
    >
      Forget Password ?
    </button>
  </mat-card-content>
</mat-card>


